module.exports = __webpack_public_path__ + "media/educators/heca-1f473c66.png";